export class AuthService {
  static logout(): void {
    localStorage.removeItem('ACCESS_TOKEN');
    localStorage.removeItem('PROFILE');
    window.location.href = '/';
  }

  static isAuthenticated(): boolean {
    return !!localStorage.getItem('ACCESS_TOKEN');
  }

  static getToken(): string | null {
    return localStorage.getItem('ACCESS_TOKEN');
  }

  static clearSession(): void {
    localStorage.removeItem('ACCESS_TOKEN');
    localStorage.removeItem('PROFILE');
  }
}
